import API from "@core/api/api";

export const fetchAllInvoice = async (params) => {
  const response = await API.get(`/invoices?${params}`);
  return response.data;
};

export const fetchInvoiceById = async (id) => {
  const response = await API.get(`/invoices/${id}`);
  return response.data;
};

export const updateInvoiceStatus = async (id, data) => {
  const response = await API.put(`/invoices/${id}/status`, data);
  return response.data;
};

export const createInvoice = async (invoice) => {
  const response = await API.post("/invoices", invoice);
  return response.data;
};

export const deleteInvoice = async (id) => {
  const response = await API.delete(`/invoices/${id}`);
  return response.data;
};

// Generate daily client invoices (Admin/Manager only)
export const generateDailyInvoices = async () => {
  const response = await API.post("/invoices/generate-daily");
  return response.data;
};

// Generate daily livreur invoices (Admin/Manager only)
export const generateDailyLivreurInvoices = async () => {
  const response = await API.post("/invoices/generate-daily-livreur");
  return response.data;
};
